import React from "react";

export default function PreviousButtonComponent(
    {
        text = "Previous",
        onClick,
        disabled = false,
        ...rest
    }
) {

    return (
        <button
            type="button"
            className="btn btn-info btn-steps mb-3 min-width-200px"
            disabled={disabled}
            onClick={onClick}
            {...rest}
        >
            <i className="fa fa-chevron-left"/> {text}
        </button>
    );

}